@if (action == 'choose') {
  <div class="card mt-4">
    <h4 class="card-header">Your subscription(s)</h4>
    <div class="card-body choose-step-2">
      <div class="form-group has-search">
        <fa-icon class="form-control-feedback" [icon]="faSearch"></fa-icon>
        <input type="text" name="search" [(ngModel)]="searchText" class="form-control" placeholder="Search by community name">
      </div>
      @for (property of subscriptions | filter:searchText; track property) {
        <div (click)="operateGate(property.id)" class="comm-div">
          <p  class="comm-p">
            @if (property.property_type == 'house') {
              <fa-icon class="l-icon" [icon]="faHouse"></fa-icon>
            }
            @if (property.property_type == 'strata') {
              <fa-icon class="l-icon" [icon]="faBuilding"></fa-icon>
            }
            {{property.name}}
            <fa-icon class="float-right" [icon]="faCircleArrowRight"></fa-icon></p>
          </div>
        }
      </div>
    </div>
  }
  @if (action == 'operate') {
    <div class="card mt-4">
      <h4 class="card-header">Entrarit - Operate Device</h4>
      <div  class="card-body choose-step-3">
        @for (device of displaydevices; track device) {
          <div class="custom-control custom-switch">
            <div class="d-inline px-2 cntrl-label">{{device.labeltxt}}</div>
            <div class="d-inline cntrl-btn">
              <label class="switch">
                <!-- <input type="checkbox"> -->
                <input type="checkbox" [value]="device.name" [id]="device.id" (change)="toggleDevice($event,device.name,device.id)">
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        }
      </div>
    </div>
  }
  @if (action == 'start') {
    <div class="card mt-4">
      <h4 class="card-header">Entrarit - Offline Mode</h4>
      <div class="card-body start-step-1">
        <!-- <h6>Users from secure api end point</h6>
        <div *ngIf="loading" class="spinner-border spinner-border-sm"></div>
        <ul *ngIf="communities">
          <li *ngFor="let community of communities">{{community.name}} {{community.address}}</li>
        </ul> -->
        <h6 class="text-center mb-20">What do you want to do?</h6>
        <div class="btn-icon text-center">
          <img src="assets/open_community_gate.png" (click)="checkSubscriptions()">
          <p class="btn-icon-txt">Open Gate(s)</p>
        </div>
      </div>
    </div>
  }
